module.exports = __webpack_public_path__ + "img/Pr24.6866aab3.png";